export default __webpack_public_path__ + "static/media/LogoEzmeral.7007cd06.png";